export const API_ENDPOINTS = {
  // Health
  HEALTH: '/health',
  HEALTH_DB: '/health/db',
  CONFIG: '/config',

  // Patients
  PATIENTS: {
    BASE: '/patients',
    BY_ID: (id: number | string) => `/patients/${id}`,
    PROFILE: (id: number | string) => `/patients/${id}/profile`,
  },

  // Vitals
  VITALS: {
    GENERATE: (patientId: number | string) => `/patients/${patientId}/generate-vitals`,
    LIST: (patientId: number | string) => `/patients/${patientId}/vitals`,
    BY_ID: (patientId: number | string, vitalId: number | string) =>
      `/patients/${patientId}/vitals/${vitalId}`,
    PUSH: (patientId: number | string) => `/patients/${patientId}/vitals/push`,
    PREVIEW: '/vitals/preview',
  },

  // Schedules
  SCHEDULES: {
    BASE: '/schedules',
    BY_ID: (id: number | string) => `/schedules/${id}`,
    PAUSE: (id: number | string) => `/schedules/${id}/pause`,
    RESUME: (id: number | string) => `/schedules/${id}/resume`,
    RUN_NOW: (id: number | string) => `/schedules/${id}/run-now`,
    RUNS: (id: number | string) => `/schedules/${id}/runs`,
    RUN_VITALS: (scheduleId: number | string, runId: number | string) => 
      `/schedules/${scheduleId}/runs/${runId}/vitals`,
  },

  // Jobs
  JOBS: {
    BASE: '/jobs',
    BY_ID: (id: number | string) => `/jobs/${id}`,
    CANCEL: (id: number | string) => `/jobs/${id}/cancel`,
  },

  OPENEMR: {
    STATUS: '/openemr/status',
    PATIENTS: '/openemr/patients',
    PATIENT: (uuid: string) => `/openemr/patients/${uuid}`,
    PATIENT_ENCOUNTERS: (uuid: string) => `/openemr/patients/${uuid}/encounter`,
    SYNC_PATIENT: (patientId: number | string) => `/openemr/patients/${patientId}/sync`,
    PATIENT_VITALS: (uuid: string) => `/openemr/patients/${uuid}/vitals`,
    CREATE_ENCOUNTER: (uuid: string) => `/openemr/patients/${uuid}/encounter`,
    REGISTER_CLIENT: '/openemr/register-client',
  },
}
